export const WarningTriangleIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2567_5652)">
      <path d="M0.666504 14H15.3332L7.99984 1.33331L0.666504 14ZM8.6665 12H7.33317V10.6666H8.6665V12ZM8.6665 9.33331H7.33317V6.66665H8.6665V9.33331Z" />
    </g>
    <defs>
      <clipPath id="clip0_2567_5652">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
